import React from 'react';
import {
  ActivityIndicator,
  Image, Text, TouchableOpacity, View,
} from 'react-native';
import { img_check, img_paykey } from '../utils/ImagesManagementUtils';
import { calcInitials, LocStr } from '../utils/Utils';
import { Save_changes } from '../utils/DictionaryManagementUtils';

const TopBar = ({
  onHomePressed,
  screenWidth,
  mainMenuState,
  setMainMenuState,
  userItem,
  animating,
  language,
  hasChangesState,
  onSavePressed,
}) => {
  const myStyles = {
    container: {
      height: 60,
      shadowColor: '#000',
      shadowOffset: { width: 0, height: 2 },
      shadowOpacity: 0.12,
      shadowRadius: 12,
      justifyContent: 'center',
    },
    topBarImageAndVer: {
      marginLeft: 24,
      marginTop: 0,
      width: 136 + 30,
      height: 60,
      position: 'absolute',
    },
    topBarImage: {
      marginLeft: 0,
      marginTop: 12,
      width: 136,
      height: 36,
      resizeMode: 'contain',
      position: 'absolute',
    },
    topBarImageButton: {
      width: 136,
      height: 60,
      marginLeft: 0,
      marginTop: 0,
      position: 'absolute',
    },
    activityIndicator: {
      position: 'absolute',
      alignSelf: 'center',
      height: 30,
      width: 30,
    },
  };
  const renderSaveChangesOrActInd = () => {
    if (animating === 2) {
      return (
        <View
          style={[
            myStyles.activityIndicator,
            { borderRadius: 15, backgroundColor: '#008cff' },
          ]}
        >
          <Image
            style={{
              marginLeft: 5,
              marginTop: 5,
              width: 20,
              height: 20,
              position: 'absolute',
            }}
            fadeDuration={0}
            source={img_check}
          />
        </View>
      );
    }
    if (animating === 1) {
      return (
        <ActivityIndicator
          animating
          color="#001a2f"
          size="small"
          style={myStyles.activityIndicator}
        />
      );
    }
    if (userItem === null || !hasChangesState) {
      return null;
    }
    return (
      <TouchableOpacity
        style={{
          width: 100,
          height: 36,
          position: 'absolute',
          justifyContent: 'center',
        }}
        activeOpacity={1}
        onPress={() => {
          onSavePressed();
        }}
      >
        <Text
          style={{
            width: 100,
            textAlign: 'right',
            fontFamily: 'Rubik-Regular',
            fontSize: 14,
            color: '#ee706d',
          }}
        >
          {LocStr(Save_changes, language)}
        </Text>
      </TouchableOpacity>
    );
  };

  return (
    <View
      style={myStyles.container}
    >
      {/* <Text style={styles.topBarTitle} >PayKeyGO</Text> */}

      <View style={myStyles.topBarImageAndVer}>
        <TouchableOpacity
          style={myStyles.topBarImageButton}
          activeOpacity={1}
          onPress={() => {
            onHomePressed();
          }}
        >
          <Image
            fadeDuration={0}
            style={myStyles.topBarImage}
            source={img_paykey}
          />
        </TouchableOpacity>
      </View>

      {userItem === null ? null : (
        <TouchableOpacity
          style={{
            width: 36,
            height: 36,
            marginLeft: screenWidth - 20 - 36,
            position: 'absolute',
            borderRadius: 18,
            backgroundColor: '#718096',
            justifyContent: 'center',
          }}
          activeOpacity={1}
          onPress={() => {
            setMainMenuState({ isMenuOpen: !mainMenuState.isMenuOpen });
          }}
        >
          <Text
            style={{
              width: 36,
              textAlign: 'center',
              fontFamily: 'Quicksand-SemiBold',
              fontSize: 16,
              color: '#fff',
            }}
          >
            {calcInitials(userItem.userFullname)}
          </Text>
        </TouchableOpacity>
      )}

      <View
        style={{
          width: 100,
          height: 36,
          marginLeft: screenWidth - 20 - 36 - 32 - 100,
          position: 'absolute',
          justifyContent: 'center',
        }}
      >
        {renderSaveChangesOrActInd()}
      </View>
    </View>
  );
};

export default TopBar;
